import { useTranslation } from "react-i18next"
import HintIcon from "../Icon/HintIcon"

const HintTitle = () => {

    const { t } = useTranslation();

    return (
        <><HintIcon /> {t('hint')}</>
    )
}

export default HintTitle;